<template>
    <div id="add-building">
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn :color="primaryColor" dark small v-bind="attrs" v-on="on" @click.stop="openAddBuildingDialog()">
                    <v-icon>mdi-domain-plus</v-icon>
                </v-btn>
            </template>
            <span>Add Building</span>
        </v-tooltip>
        <v-dialog v-model="addBuildingDialog" max-width="767" persistent>
            <v-card>
                <v-card-title>
                    Add Building
                </v-card-title>
                <v-card-text>
                    <v-form ref="addBuildingForm" v-model="valid" lazy-validation>
                        <v-text-field v-model="currentBuilding.name" label="Name" :rules="nameRules" required>
                        </v-text-field>
                        <v-text-field v-model="currentBuilding.maxOccupancy" label="Max Occupancy"
                            :rules="maxOccupancyRules" required type="number">
                        </v-text-field>
                        <v-select v-model="currentBuilding.maxRoommateRequest" :items="maxRoommateRequestItems"
                            label="Max Roommate Request" :rules="maxRoommateRequestRules" required>
                        </v-select>
                        <v-select v-model="currentBuilding.minYearOfStudy" :items="minYearOfStudyItems"
                            label="Min Year Of Study" :rules="minYearOfStudyRules" required>
                        </v-select>
                        <v-select v-model="currentBuilding.mealPlanRequired" :items="mealPlanRequiredItems"
                            label="Meal Plan Required" :rules="mealPlanRequiredRules" required>
                        </v-select>
                        <v-card-subtitle class="font-weight-bold pb-1 px-0">Gender Restriction</v-card-subtitle>
                        <v-checkbox v-model="currentBuilding.genderRestriction" dense hide-details label="Male"
                            value="male">
                        </v-checkbox>
                        <v-checkbox v-model="currentBuilding.genderRestriction" dense hide-details label="Female"
                            value="female">
                        </v-checkbox>
                        <v-checkbox v-model="currentBuilding.genderRestriction" dense label="Non-Binary"
                            value="NonBinary">
                        </v-checkbox>
                        <v-card-subtitle class="font-weight-bold pb-1 px-0">Additional Information</v-card-subtitle>
                        <v-file-input v-model="uploadFileContractConditions" accept="application/pdf"
                            label="Contract Condition" placeholder="Please select a PDF file" show-size></v-file-input>
                        <v-select v-model="currentBuilding.internationalOnly" :items="internationalOnlyItems"
                            label="International Only" :rules="internationalOnlyRules" required>
                        </v-select>
                        <v-select v-model="currentBuilding.enabled" :items="enabledItems" label="Enabled"
                            :rules="enabledRules" required>
                        </v-select>
                        <v-textarea v-model="currentBuilding.notes" auto-grow counter="512" label="Notes"
                            :rules="noteRules" outlined>
                        </v-textarea>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn ref="addBtn" class="white--text" :color="successColor" :disabled="!valid"
                        @click="openAddBuildingConfirmationDialog()">
                        Add
                    </v-btn>
                    <v-btn ref="resetBtn" class="white--text" :color="primaryColor" @click="resetForm()">
                        Reset
                    </v-btn>
                    <v-btn ref="closeBtn" :color="warningColor" @click="closeAddBuildingDialog()">
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="addBuildingConfirmationDialog" max-width="540">
            <v-card ref="addBuildingConfirmationCard">
                <v-card-title>Confirmation</v-card-title>
                <v-card-text>
                    Are you sure you would like to add <b>{{ currentBuilding.name }}</b> as a Building? Please click
                    confirm to proceed.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn ref="confirmBtn" :color="dangerColor" text @click="addBuilding()">
                        Confirm
                    </v-btn>
                    <v-btn :color="warningColor" text @click="closeAddBuildingConfirmationDialog()">
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'buildings-add',
    data() {
        return {
            addBuildingConfirmationDialog: false,
            addBuildingDialog: false,
            currentBuilding: {
                enabled: 1,
                genderRestriction: [],
                internationalOnly: 0,
                name: '',
                notes: '',
                maxOccupancy: 0,
                maxRoommateRequest: 1,
                mealPlanRequired: 0,
                minYearOfStudy: 1
            },
            enabledItems: [{
                    text: 'Yes',
                    value: 1
                },
                {
                    text: 'No',
                    value: 0
                }
            ],
            enabledRules: [
                v => !(v === "") || 'Enabled is required',
            ],
            internationalOnlyItems: [{
                    text: 'Yes',
                    value: 1
                },
                {
                    text: 'No',
                    value: 0
                }
            ],
            internationalOnlyRules: [
                v => !(v === "") || 'International only is required',
            ],
            maxOccupancyRules: [
                v => !(v === "") || 'Max occupancy is required',
                v => (!(v === "") && v >= 0 && v <= 300) || 'Max occupancy must be between 0 and 300',
            ],
            maxRoommateRequestItems: [{
                    text: '1',
                    value: 1
                },
                {
                    text: '2',
                    value: 2
                },
                {
                    text: '3',
                    value: 3
                },
                {
                    text: '4',
                    value: 4
                },
                {
                    text: '5',
                    value: 5
                }
            ],
            maxRoommateRequestRules: [
                v => !(v === "") || 'Max roommate request is required',
            ],
            mealPlanRequiredItems: [{
                    text: 'Yes',
                    value: 1
                },
                {
                    text: 'No',
                    value: 0
                }
            ],
            mealPlanRequiredRules: [
                v => !(v === "") || 'Meal plan required is required',
            ],
            minYearOfStudyItems: [{
                    text: '1',
                    value: 1
                },
                {
                    text: '2',
                    value: 2
                },
                {
                    text: '3',
                    value: 3
                },
                {
                    text: '4',
                    value: 4
                }
            ],
            minYearOfStudyRules: [
                v => !(v === "") || 'Min year of study is required',
            ],
            nameRules: [
                v => !!v || 'Name is required',
                v => (v && v.length >= 2) || 'Name must be more than 2 characters',
            ],
            noteRules: [
                v => (!v || (v && v.length >= 0 && v.length <= 512)) || 'Note must be between 0 and 512 characters',
            ],
            uploadFileContractConditions: '',
            valid: true
        }
    },
    methods: {
        addBuilding() {
            const that = this;
            const formData = new FormData();
            let api = `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?setBuilding`;

            // Parse array into string
            formData.append('mode', 'setBuilding');
            formData.append('data', JSON.stringify(this.currentBuilding));
            formData.append('uploadFileContractConditions', this.uploadFileContractConditions);

            // Loading icon
            this.$refs.confirmBtn.loading = true;

            // Post request
            fetch(api, {
                    method: 'POST',
                    body: formData
                })
                .then(function (response) {
                    // Return JSON response
                    return response.json();
                })
                .then(function (json) {
                    // Success result
                    if (json.result.match(/OK/i)) {
                        that.$emit('setNotification', '#1dc9b7', 'mdi-check-circle', `${that.currentBuilding.name} has been successfully added as a Building.`, true);
                    } else if (json.message.match(/UNAUTHORIZED/i)) {
                        that.$emit('setNotification', '#f64e60', 'mdi-alert-outline', `You are not authorized to perform this action. Please refresh your application.`, true);
                    } else {
                        that.$emit('setNotification', '#ffb822', 'mdi-alert-circle', `${that.currentBuilding.name} could not be added as a Building. Please contact your system administrator.`, true);
                    }

                    that.$emit('refreshData');
                    that.$refs.confirmBtn.loading = false;
                    that.closeAddBuildingConfirmationDialog();
                    that.closeAddBuildingDialog();
                })
                .catch(function () {
                    that.$emit('refreshData');
                    that.$refs.confirmBtn.loading = false;
                    that.$emit('setNotification', '#f64e60', 'mdi-alert-outline', `An error occurred. Please contact your system administrator.`, true);
                });
        },
        closeAddBuildingConfirmationDialog() {
            this.addBuildingConfirmationDialog = false;
        },
        closeAddBuildingDialog() {
            this.addBuildingDialog = false;
        },
        openAddBuildingConfirmationDialog() {
            // Validate form before confirmation
            if (this.$refs.addBuildingForm.validate()) {
                this.addBuildingConfirmationDialog = true;
            }
        },
        openAddBuildingDialog() {
            // Reset form
            this.resetForm();
            this.addBuildingDialog = true;
        },
        resetForm() {
            // Reset form validation
            this.resetFormValidation();

            // Reset current building
            this.currentBuilding.enabled = 1;
            this.currentBuilding.genderRestriction = [];
            this.currentBuilding.internationalOnly = 0;
            this.currentBuilding.name = '';
            this.currentBuilding.notes = '';
            this.currentBuilding.maxOccupancy = 0;
            this.currentBuilding.maxRoommateRequest = 1;
            this.currentBuilding.mealPlanRequired = 1;
            this.currentBuilding.minYearOfStudy = 1;
            this.uploadFileContractConditions = '';
        },
        resetFormValidation() {
            if (this.$refs.addBuildingForm) {
                this.$refs.addBuildingForm.resetValidation();
            }
        },
    },
    computed: {
        dangerColor() {
            return '#f64e60';
        },
        primaryColor() {
            return '#5867dd';
        },
        successColor() {
            return '#1dc9b7';
        },
        warningColor() {
            return '#ffb822'
        }
    }
}
</script>

<style scoped>
.v-input--checkbox {
    margin-top: 0;
}
</style>